import { Component, forwardRef, input } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { JsonPipe, NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TrimDirective } from '../../directives/trim.directive';

@Component({
  selector: 'app-password',
  standalone: true,
  imports: [JsonPipe, NgClass, TranslateModule, TrimDirective],
  templateUrl: './password.component.html',
  styleUrl: './password.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PasswordComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PasswordComponent),
      multi: true
    }
  ]
})
export class PasswordComponent extends InputComponent implements ControlValueAccessor {
  override label = input<string>('input.password') ;
  hidePassword: boolean = true;

}
